var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bgfunds-intro bgfunds-main-module"},[_c('h3',{staticClass:"bgfunds-heading"},[_vm._v(_vm._s(_vm.data.heading))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.bodyText)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }